import styled from 'styled-components';

export const ColorBox = styled.div`
  position: relative;
  overflow: hidden;
  width: 36px;
  height: 36px;
  border: 2px solid white;
  border-radius: 50%;
`;

export const ColorInput = styled.input`
  cursor: pointer;
  position: absolute;
  width: 56px;
  height: 56px;
  right: -8px;
  top: -8px;
  border: none;

  &:after {
    content: "+";
    position: absolute;
    background: var(--color-background-secondary);
    width: 32px;
    height: 32px;
    right: 10px;
    top: 10px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 32px;
    font-size: 1.25rem;
    color: var(--color-text-primary);
    border-radius: 50%;
  }

  &:focus {
    &:after {
      opacity: 0.8;
    }
  }
`;
